import React from "react";
import { LegalPageLayout } from "./LegalPageLayout";

// TODO: заменить плейсхолдеры на согласованный юристами текст договора публичной оферты.
const sections = [
  {
    heading: "1. Общие положения",
    text: "[Место для текста: кто выступает исполнителем/продавцом, что признаётся акцептом оферты, на каких условиях заключается договор.]",
  },
  {
    heading: "2. Предмет договора",
    text: "[Место для текста: описание услуг/товаров, на которые распространяется оферта.]",
  },
  {
    heading: "3. Порядок заключения договора",
    text: "[Место для текста: как именно происходит акцепт оферты — оформление заявки, оплата, подписание и т.д.]",
  },
  {
    heading: "4. Права и обязанности сторон",
    text: "[Место для текста: обязанности исполнителя и заказчика.]",
  },
  {
    heading: "5. Стоимость и порядок оплаты",
    text: "[Место для текста: порядок ценообразования, способы и сроки оплаты.]",
  },
  {
    heading: "6. Ответственность сторон",
    text: "[Место для текста: условия ответственности за неисполнение обязательств.]",
  },
  {
    heading: "7. Порядок разрешения споров",
    text: "[Место для текста: досудебный порядок, применимое право, подсудность.]",
  },
  {
    heading: "8. Реквизиты и контакты",
    text: "[Место для текста: юридические реквизиты компании и контактные данные.]",
  },
];

const PublicOffer = () => (
  <LegalPageLayout
    title="Договор публичной оферты"
    updatedAt="[Дата последнего обновления]"
    sections={sections}
  />
);

export default PublicOffer;
